// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nini[data-v-10743011] {\n  background: #021b5f;\n  border-bottom: 1px solid #2399f1;\n  height: 50px;\n}\n.nini ul li a[data-v-10743011]:hover :active {\n  background: #03175c;\n}\n", ""]);
// Exports
module.exports = exports;
